import React from "react";
import "./Home.css";

const Support = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
        {/* Animated Background Blurs */}
        <div className="absolute top-10 left-10 w-72 h-72 bg-[#4299f5] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-1/2 w-72 h-72 bg-pink-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
        
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-4 animate-fade-in-up" style={{fontFamily: 'Montserrat, sans-serif'}}>
            Support Center
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 animate-fade-in-up animation-delay-200">
            We're here to help! Get in touch with our support team.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <div className="bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Contact Cards */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {/* Email Support */}
            <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-transparent hover:border-[#4299f5] transition-all duration-300">
              <div className="w-16 h-16 bg-[#4299f5] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                Email Support
              </h3>
              <p className="text-gray-600 text-center mb-4">
                Get help via email
              </p>
              <a 
                href="mailto:trivanahospitality@gmail.com" 
                className="block text-center text-[#4299f5] hover:text-[#3a8fe5] font-semibold transition-colors"
              >
                trivanahospitality@gmail.com
              </a>
            </div>

            {/* Phone Support */}
            <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-transparent hover:border-[#4299f5] transition-all duration-300">
              <div className="w-16 h-16 bg-[#4299f5] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                Phone Support
              </h3>
              <p className="text-gray-600 text-center mb-4">
                Call us for immediate help
              </p>
              <a 
                href="tel:+919257734350" 
                className="block text-center text-[#4299f5] hover:text-[#3a8fe5] font-semibold transition-colors"
              >
                +91 9257734350
              </a>
            </div>

            {/* Live Chat */}
            <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-transparent hover:border-[#4299f5] transition-all duration-300">
              <div className="w-16 h-16 bg-[#4299f5] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                Contact Form
              </h3>
              <p className="text-gray-600 text-center mb-4">
                Send us a message
              </p>
              <a 
                href="/contact" 
                className="block text-center text-[#4299f5] hover:text-[#3a8fe5] font-semibold transition-colors"
              >
                Go to Contact Page
              </a>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="bg-white rounded-2xl p-8 sm:p-12 shadow-xl border-2 border-transparent hover:border-[#4299f5] transition-all duration-300">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8 text-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
              Frequently Asked Questions
            </h2>

            <div className="space-y-6">
              {/* FAQ Item 1 */}
              <div className="border-l-4 border-[#4299f5] pl-6 py-4">
                <h3 className="text-xl font-bold text-gray-900 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                  How do I get started with Trivana Hospitality?
                </h3>
                <p className="text-gray-700">
                  Getting started is easy! Simply sign up for an account, choose your plan, and our team will guide you through the setup process. We offer comprehensive onboarding support to ensure you're up and running smoothly.
                </p>
              </div>

              {/* FAQ Item 2 */}
              <div className="border-l-4 border-[#4299f5] pl-6 py-4">
                <h3 className="text-xl font-bold text-gray-900 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                  What payment methods do you accept?
                </h3>
                <p className="text-gray-700">
                  We accept all major credit cards, debit cards, and UPI payments. For enterprise plans, we also offer invoice-based billing and bank transfers.
                </p>
              </div>

              {/* FAQ Item 3 */}
              <div className="border-l-4 border-[#4299f5] pl-6 py-4">
                <h3 className="text-xl font-bold text-gray-900 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                  Can I upgrade or downgrade my plan?
                </h3>
                <p className="text-gray-700">
                  Yes! You can upgrade or downgrade your plan at any time. Changes will be reflected in your next billing cycle, and we'll prorate any differences accordingly.
                </p>
              </div>

              {/* FAQ Item 4 */}
              <div className="border-l-4 border-[#4299f5] pl-6 py-4">
                <h3 className="text-xl font-bold text-gray-900 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                  Do you offer training for my staff?
                </h3>
                <p className="text-gray-700">
                  Absolutely! We provide comprehensive training sessions for your staff, including video tutorials, documentation, and live training sessions. Our support team is always available to answer any questions.
                </p>
              </div>

              {/* FAQ Item 5 */}
              <div className="border-l-4 border-[#4299f5] pl-6 py-4">
                <h3 className="text-xl font-bold text-gray-900 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                  Is my data secure?
                </h3>
                <p className="text-gray-700">
                  Security is our top priority. We use industry-standard encryption, regular security audits, and comply with all data protection regulations. Your data is backed up regularly and stored securely.
                </p>
              </div>

              {/* FAQ Item 6 */}
              <div className="border-l-4 border-[#4299f5] pl-6 py-4">
                <h3 className="text-xl font-bold text-gray-900 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                  What are your support hours?
                </h3>
                <p className="text-gray-700">
                  Our email support is available 24/7. Phone support is available Monday to Saturday, 9 AM to 6 PM IST. For enterprise customers, we offer dedicated 24/7 support.
                </p>
              </div>
            </div>

            {/* Still Have Questions Section */}
            <div className="mt-12 p-8 bg-gradient-to-r from-[#4299f5]/10 to-purple-500/10 rounded-xl border-2 border-[#4299f5]/30">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center" style={{fontFamily: 'Montserrat, sans-serif'}}>
                Still have questions?
              </h3>
              <p className="text-gray-700 text-center mb-6">
                Can't find the answer you're looking for? Please reach out to our friendly support team.
              </p>
              <div className="flex justify-center">
                <a 
                  href="/contact" 
                  className="inline-block px-8 py-3 bg-[#4299f5] text-white font-semibold rounded-lg hover:bg-[#3a8fe5] transition-all shadow-lg"
                  style={{fontFamily: 'Montserrat, sans-serif'}}
                >
                  Contact Support
                </a>
              </div>
            </div>
          </div>

          {/* Additional Resources */}
          <div className="mt-12 grid md:grid-cols-2 gap-6">
            {/* Documentation */}
            <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-transparent hover:border-[#4299f5] transition-all duration-300">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-[#4299f5] rounded-full flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900" style={{fontFamily: 'Montserrat, sans-serif'}}>
                  Documentation
                </h3>
              </div>
              <p className="text-gray-700 mb-4">
                Browse our comprehensive documentation to learn about all features and best practices.
              </p>
              <a href="#" className="text-[#4299f5] hover:text-[#3a8fe5] font-semibold inline-flex items-center">
                View Documentation
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>

            {/* Video Tutorials */}
            <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-transparent hover:border-[#4299f5] transition-all duration-300">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-[#4299f5] rounded-full flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900" style={{fontFamily: 'Montserrat, sans-serif'}}>
                  Video Tutorials
                </h3>
              </div>
              <p className="text-gray-700 mb-4">
                Watch step-by-step video tutorials to quickly learn how to use our platform effectively.
              </p>
              <a href="#" className="text-[#4299f5] hover:text-[#3a8fe5] font-semibold inline-flex items-center">
                Watch Tutorials
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>

          {/* Back to Home */}
          <div className="mt-10 text-center">
            <a 
              href="/" 
              className="inline-flex items-center text-[#4299f5] hover:text-[#3a8fe5] font-semibold text-lg transition-colors duration-200"
              style={{fontFamily: 'Montserrat, sans-serif'}}
            >
              <span className="mr-2">←</span> Back to Home
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
